import { PageLink } from "../../../../../../_metronic/layout/core"
import { DEFAULT_ROLES } from "../../../../../common/core/_consts"
import { MaskOption } from "./types"

export const MESSAGE_BREADCRUMBS: Array<PageLink> = [
    {
        title: 'Шаблоны',
        path: '/settings/message/templates',
        isSeparator: false,
        isActive: false,
        roles: DEFAULT_ROLES,
    },  
    {
        title: 'Отправители',
        path: '/settings/message/senders',
        isSeparator: false,
        isActive: true,
        roles: DEFAULT_ROLES,
    },
]

export const MASK_OPTIONS: MaskOption[] = [
  { label: 'Сумма', value: '{AMOUNT}' },
  { label: 'Баланс', value: '{BALANCE}' },
  { label: 'Карта', value: '{CARD_MASK}' },
  { label: 'Отправитель', value: '{SENDER}' },
  { label: 'Банк отправителя', value: '{SENDER_BANK}' },
  { label: 'Дата', value: '{DATE}' },
  { label: 'Время', value: '{TIME}' },
  { label: 'Комиссия', value: '{FEE}' },
]